import {isRTL} from '../../../../Localization';

const en = {
    lockedByUser:
        'You are already revising this very same text in another window.\n Revising the same text in two windows is likely to lead to loss of data.',
    lockedByAnotherUser:
        'This text is currently being revised by {user}. The form will appear in read-only mode.',
    approveLabel: 'Ok',
    readOnlyLabel: 'Read-only',
    editLabel: 'Edit'
};

const he = {
    lockedByUser:
        'קסט זה נמצא בעריכה על ידך במסך אחר. \n עריכה של אותו טקסט בשני מסכים במקביל עלולה לגרום לאיבוד מידע.',
    lockedByAnotherUser: 'טקסט זה נמצא בעריכה ע"י {user}. המסך יוצג לקריאה בלבד.\n',
    approveLabel: 'אישור',
    readOnlyLabel: 'קריאה בלבד',
    editLabel: 'עריכה'
};

export const htmlFormMessagesText = isRTL() ? he : en;
